"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useCatalogPreferences_1 = __importDefault(require("stremio/common/useCatalogPreferences"));
// @ts-ignore - CommonJS module
var useBoard = require('stremio/routes/Board/useBoard');
var useHomeScreenOptions = function () {
    var board = useBoard()[0];
    var catalogPrefs = (0, useCatalogPreferences_1.default)();
    var catalogs = (0, react_1.useMemo)(function () {
        return (board === null || board === void 0 ? void 0 : board.catalogs) || [];
    }, [board === null || board === void 0 ? void 0 : board.catalogs]);
    var heroSectionEnabledToggle = (0, react_1.useMemo)(function () { return ({
        checked: catalogPrefs.getHeroSectionEnabled(),
        onClick: function () {
            catalogPrefs.setHeroSectionEnabled(!catalogPrefs.getHeroSectionEnabled());
        }
    }); }, [catalogPrefs]);
    var getCatalogToggle = (0, react_1.useCallback)(function (catalog) {
        var pref = catalogPrefs.getCatalogPreference(catalog);
        return {
            checked: pref ? pref.enabled : true,
            onClick: function () {
                catalogPrefs.setCatalogPreference(catalog, {
                    enabled: !(pref ? pref.enabled : true),
                });
            }
        };
    }, [catalogPrefs]);
    var getCatalogHeroButton = (0, react_1.useCallback)(function (catalog) {
        var _a;
        var pref = catalogPrefs.getCatalogPreference(catalog);
        // Default to first catalog only if preference is undefined
        var originalIndex = catalogs.indexOf(catalog);
        var isHeroEnabled = (_a = pref === null || pref === void 0 ? void 0 : pref.showInHero) !== null && _a !== void 0 ? _a : (originalIndex === 0);
        var isCatalogEnabled = pref ? pref.enabled : true;
        var heroSectionEnabled = catalogPrefs.getHeroSectionEnabled();
        var disabled = !isCatalogEnabled || !heroSectionEnabled;
        return {
            checked: isHeroEnabled,
            disabled: disabled,
            onClick: function () {
                if (disabled)
                    return;
                catalogPrefs.setCatalogPreference(catalog, {
                    showInHero: !isHeroEnabled,
                });
            }
        };
    }, [catalogPrefs, catalogs]);
    return {
        heroSectionEnabledToggle: heroSectionEnabledToggle,
        getCatalogToggle: getCatalogToggle,
        getCatalogHeroButton: getCatalogHeroButton,
        reorderCatalogs: catalogPrefs,
        catalogs: catalogs,
    };
};
exports.default = useHomeScreenOptions;
